import { Component, OnInit, Inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-request-submit-rb-dailog',
  templateUrl: './request-submit-rb-dailog.component.html',
  styleUrls: ['./request-submit-rb-dailog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class RequestSubmitRbDailog implements OnInit {
  patronDetails: any;
  type: string;

  constructor(
    private _dialogRef: MatDialogRef<RequestSubmitRbDailog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.patronDetails = this.data.details;
    this.type = this.data.type;
  }

  okayClick() {
    this._dialogRef.close('ok');
  }

  closeClick() {
    this._dialogRef.close('close');
  }
}
